module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"companions\"-in-los-angeles-california-659b97cc75d58e98d0534d864e5c5a80.png";